<template>
  <div class="stage-table">
    <table>
      <thead>
        <tr>
          <td>
            №
          </td>
          <td>
            Дата, время
          </td>
          <td>
            Стадия
          </td>
          <td>
            Дата
          </td>
          <td>
            Сведения о подзаконных актах
          </td>
          <td>
            Пользователь
          </td>
          <td>
            Действия
          </td>
        </tr>
      </thead>
      <tbody>
        <template
          v-for="(stage, index) in stages"
        >
          <tr :key="index">
            <td :rowspan="stage.data.length">
              {{ index + 1 }}
            </td>
            <td :rowspan="stage.data.length">
              {{ stage.createdDate }}
            </td>
            <td :rowspan="stage.data.length">
              {{ stage.stageName }}
            </td>
            <td>
              <LawNormViewStageDate
                :stage="stage.data[0]"
              />
            </td>
            <td>
              <LawNormViewStageDateCbd
              :stage="stage.data[0]"
              />
            </td>
            <td :rowspan="stage.data.length">
              {{  stage.user }}
            </td>
            <td :rowspan="stage.data.length">
              <div
                class="norm_table-actions"
              >
                <span
                  class="pro-icon-pencil norm_table-pencil"
                  @click="editStage(stage)"
                />
                <span
                  class="norm_table-remove"
                  @click="deleteStage(stage)"
                >
                <i class="fa fa-trash" aria-hidden="true"></i>
              </span>
              </div>
            </td>
          </tr>

          <template v-if="stage.data.length > 1">
            <tr
              v-for="(dataStage, index) in stage.data.slice(1)"
              :key="index"
            >
              <td>
                <LawNormViewStageDate
                  :stage="dataStage"
                />
              </td>
              <td>
                <LawNormViewStageDateCbd
                  :stage="dataStage"
                />
              </td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>
  import LawNormViewStageDate from '@/components/law/LawNormViewStageDate.vue'
  import LawNormViewStageDateCbd from '@/components/law/LawNormViewStageDateCbd.vue'

  export default {
    name: 'LawNormViewStageTable',
    components: {
      LawNormViewStageDate,
      LawNormViewStageDateCbd
    },
    props: {
      stages: {
        type: Array,
        required: true
      }
    },
    methods: {
      editStage(stage) {
        this.$emit('edit-stage', stage)
      },
      deleteStage(stage) {
        this.$emit('delete-stage', stage)
      }
    }
  }
</script>
<style lang="scss">
  .stage-table {
    margin-top: 20px;

    table {
      thead {
        tr {
          td {
            background:#cccccc;
            font-weight: 600;
          }
        }
      }
    }
  }

  .norm_table-actions {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-evenly;
  }

  .norm_table-actions span {
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
</style>
